import { useMemo } from 'react';

import qs from 'qs';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

type Result = ModelHookResult<{
	isDataAfterRollout: boolean;
	dashboardCorgiBetaLink: string;
	redashDashboardLink: string | null;
	resultsChartioLink: string;
}>;

export function useResultsLinks({
	createdAt,
	id,
	messageType,
}: {
	id: string;
	messageType: { readonly id: string; readonly name: string; readonly type: string };
	createdAt: string;
}): Result {
	// The day we rolled out the Send Order Results Dashboard
	// Data prior to this date is not available in comms_data_service
	const rolloutDate = new Date('2020-05-04');
	const createdAtDate = new Date(createdAt);

	const utilityContext = useUtilityContext();
	const environment = utilityContext.environment.getEnvironment();

	const redashEnvironment = environment === 'production' ? 'production' : 'staging';

	const redashDashboardLink = useMemo(() => {
		const queryString = qs.stringify(
			{
				p_send_order_created_at: createdAt,
				p_send_order_id: id,
			},
			{ addQueryPrefix: true },
		);
		switch (messageType.type) {
			case 'aa_sign_ask':
			case 'aa_augmented_sign_ask':
				return `https://${redashEnvironment}-redash-server.ojos-alligator.ts.net/dashboard/comms-stack-manual-sends-reporting${queryString}`;
			case 'aa_editorial':
				return `https://${redashEnvironment}-redash-server.ojos-alligator.ts.net/dashboard/manuals-sends-editorial-only-reporting${queryString}`;
			case 'aa_membership_ask':
				return `https://${redashEnvironment}-redash-server.ojos-alligator.ts.net/queries/3184/source${queryString}`;
			default:
				return null;
		}
	}, [createdAt, id, messageType, redashEnvironment]);

	return {
		data: {
			isDataAfterRollout: createdAtDate >= rolloutDate,
			dashboardCorgiBetaLink: `/admin/comms/send_orders/${id}/results`,
			redashDashboardLink,
			resultsChartioLink: `https://chartio.com/changeorg/tako-email-reporting/?SEND_ORDER_ID=${id}`,
		},
	};
}
